import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { MANIFESTO, IMAGES, waLink } from "../../data";
import { Reveal } from "./Reveal";

export const Manifesto = () => (
  <section
    id="chi-siamo"
    className="relative border-y border-white/10 bg-[#050e1f] py-24 sm:py-32"
    data-testid="manifesto-section"
  >
    <div className="mx-auto max-w-6xl px-5">
      <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        {/* left: about + image */}
        <div>
          <Reveal>
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#FFC400]">
              / Chi siamo
            </p>
            <h2 className="font-display text-3xl font-extrabold tracking-tighter text-white sm:text-5xl">
              Un professionista affidabile al tuo servizio
            </h2>
            <p className="mt-5 max-w-lg text-white/70">
              ELETTRIKPRO è il servizio di <strong className="text-white">Carlo</strong>,
              elettricista qualificato con base a San Giorgio a Cremano e operativo
              in tutta Napoli e provincia. Interventi rapidi, sicuri e risolutivi,
              con soluzioni efficaci senza perdite di tempo.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative mt-8 overflow-hidden rounded-3xl border border-white/10">
              <img
                src={IMAGES.testing}
                alt="Carlo di ELETTRIKPRO effettua una diagnosi con il tester"
                className="aspect-[16/11] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050e1f] to-transparent" />
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="manifesto-whatsapp-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FFC400] px-6 py-3.5 font-bold text-[#0B1F3A] transition-transform duration-200 hover:scale-[1.03]"
            >
              <MessageCircle className="h-5 w-5" strokeWidth={2.5} /> Parla con Carlo
            </a>
          </Reveal>
        </div>

        {/* right: numbered chapters */}
        <div className="flex flex-col gap-4">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.08}>
              <motion.div
                whileHover={{ x: 8 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-6 sm:p-7"
              >
                <span className="pointer-events-none absolute -right-2 -top-6 select-none font-display text-8xl font-extrabold leading-none text-white/[0.04]">
                  {m.n}
                </span>
                <div className="relative">
                  <span className="font-display text-sm font-bold text-[#FFC400]">
                    {m.n}
                  </span>
                  <h3 className="mt-1 font-display text-xl font-bold text-white">
                    {m.title}
                  </h3>
                  <p className="mt-2 max-w-md text-sm text-white/60">{m.desc}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Manifesto;
